// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import moment from 'moment'
import * as GoogleMaps from 'vue2-google-maps'

Vue.config.productionTip = false
Vue.use(GoogleMaps, {
  load: {
    key: "AIzaSyAxEHYU3jv-RmmOKlN1Xo4ENg7QMrredtE",
    libraries: "places" // necessary for places input
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY')
  }
})



// WEBPACK FOOTER //
// ./src/main.js